import { NARROW_VIEW_LIMIT } from "../constants/Env";

export const getIsNarrowView = environment => {
  return environment.screenWidth <= NARROW_VIEW_LIMIT;
};
